import React, { useState } from 'react';
import { REFUSAL_CATEGORIES } from '../../config/agent.config';
import type { RefusalCategory, RefusalReason } from '../../types/agent.types';

interface RefusalPanelProps {
  onConfirm: (reason: RefusalReason) => void;
  onCancel: () => void;
}

export const RefusalPanel: React.FC<RefusalPanelProps> = ({ onConfirm, onCancel }) => {
  const [category, setCategory] = useState<RefusalCategory>('already_handled');
  const [comment, setComment] = useState('');

  const handleConfirm = () => {
    onConfirm({ category, comment: comment || undefined });
  };

  return (
    <div className="agent-refusal-panel">
      <div className="agent-refusal-title">Raison du refus</div>
      <div className="agent-refusal-options">
        {REFUSAL_CATEGORIES.map((option) => (
          <label key={option.id} className="agent-refusal-option">
            <input
              type="radio"
              name="refusal-category"
              checked={category === option.id}
              onChange={() => setCategory(option.id)}
            />
            {option.label}
          </label>
        ))}
      </div>
      <textarea
        className="agent-refusal-comment"
        placeholder="Commentaire (optionnel)..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <div className="agent-refusal-actions">
        <button className="agent-refusal-btn-cancel" onClick={onCancel}>Annuler</button>
        <button className="agent-refusal-btn-confirm" onClick={handleConfirm}>
          Confirmer le refus
        </button>
      </div>
    </div>
  );
};
